var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { NewFirmwareUpgradeForm, transformFormStateToRequest, } from '@/components/node-tools/firmware-upgrade/new-firmware-upgrade';
import { withAuthenticationRequired } from '@/hocs/authentication-required';
import { useDocTitle } from '@/hooks/doc-title';
import { PAGE_TITLE_ID } from '@/constants/ids';
import { useCreateNodeUpgrade } from '@/api/system/node-upgrade';
import { FIRMWARE_UPGRADE_TASKS_ROUTE } from '@/constants/routes';
export var NEW_FIRMWARE_UPGRADE_RIGHTS = ['settings.services.node_upgrade.edit'];
function NewFirmwareUpgrade() {
    var _this = this;
    var t = useTranslation().t;
    var pageTitle = t('pages.firmware_upgrade_new.title');
    useDocTitle(pageTitle);
    var navigate = useNavigate();
    var location = useLocation();
    useEffect(function () {
        var clearLocationState = function () {
            navigate(location.pathname, { replace: true });
        };
        window.addEventListener('beforeunload', clearLocationState);
        return function () {
            window.removeEventListener('beforeunload', clearLocationState);
        };
    }, [location.pathname, navigate]);
    var createNodeUpgrade = useCreateNodeUpgrade();
    var handleSubmit = useCallback(function (submittedFormData) { return __awaiter(_this, void 0, void 0, function () {
        var request, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = transformFormStateToRequest(submittedFormData);
                    if (!request)
                        return [2 /*return*/];
                    return [4 /*yield*/, createNodeUpgrade(request)
                        // On Success navigate to tasks page
                    ];
                case 1:
                    result = _a.sent();
                    // On Success navigate to tasks page
                    if (result) {
                        navigate(FIRMWARE_UPGRADE_TASKS_ROUTE);
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [createNodeUpgrade, navigate]);
    return (_jsxs(Box, __assign({ margin: 2 }, { children: [_jsx(Typography, __assign({ id: PAGE_TITLE_ID, component: "h2", variant: "h2", gutterBottom: true }, { children: pageTitle })), _jsx(NewFirmwareUpgradeForm, { ariaLabelledBy: PAGE_TITLE_ID, onSubmit: handleSubmit, permissions: { hasEditPermission: true } })] })));
}
export default withAuthenticationRequired(NewFirmwareUpgrade, {
    rights: NEW_FIRMWARE_UPGRADE_RIGHTS,
});
